interface TrashIconProps {
  fill?: string;
}
const TrashIcon = ({ fill }: TrashIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.22132 2.22139C6.06489 2.37783 5.99992 2.55014 5.99992 2.66666V3.33332H9.99992V2.66666C9.99992 2.55014 9.93495 2.37783 9.77851 2.22139C9.62208 2.06496 9.44976 1.99999 9.33325 1.99999H6.66659C6.55007 1.99999 6.37776 2.06496 6.22132 2.22139ZM11.3333 3.33332V2.66666C11.3333 2.1165 11.0649 1.62215 10.7213 1.27859C10.3778 0.935021 9.88341 0.666656 9.33325 0.666656H6.66659C6.11643 0.666656 5.62208 0.935021 5.27851 1.27859C4.93495 1.62215 4.66659 2.1165 4.66659 2.66666V3.33332H1.99992C1.63173 3.33332 1.33325 3.6318 1.33325 3.99999C1.33325 4.36818 1.63173 4.66666 1.99992 4.66666H2.66659V13.3333C2.66659 13.8835 2.93495 14.3778 3.27851 14.7214C3.62208 15.065 4.11643 15.3333 4.66659 15.3333H11.3333C11.8834 15.3333 12.3778 15.065 12.7213 14.7214C13.0649 14.3778 13.3333 13.8835 13.3333 13.3333V4.66666H13.9999C14.3681 4.66666 14.6666 4.36818 14.6666 3.99999C14.6666 3.6318 14.3681 3.33332 13.9999 3.33332H11.3333ZM3.99992 4.66666V13.3333C3.99992 13.4498 4.06489 13.6221 4.22132 13.7786C4.37776 13.935 4.55007 14 4.66659 14H11.3333C11.4498 14 11.6221 13.935 11.7785 13.7786C11.9349 13.6221 11.9999 13.4498 11.9999 13.3333V4.66666H3.99992ZM6.66659 6.66666C7.03478 6.66666 7.33325 6.96513 7.33325 7.33332V11.3333C7.33325 11.7015 7.03478 12 6.66659 12C6.2984 12 5.99992 11.7015 5.99992 11.3333V7.33332C5.99992 6.96513 6.2984 6.66666 6.66659 6.66666ZM9.33325 6.66666C9.70144 6.66666 9.99992 6.96513 9.99992 7.33332V11.3333C9.99992 11.7015 9.70144 12 9.33325 12C8.96506 12 8.66659 11.7015 8.66659 11.3333V7.33332C8.66659 6.96513 8.96506 6.66666 9.33325 6.66666Z"
        fill={fill ?? "#313131"}
      />
    </svg>
  );
};

export default TrashIcon;
